import i18next from 'i18next';
import { ApiClientExceptionErrorCode, IApiClientException } from 'types/api';

export class ApiClientException implements IApiClientException {
  errors: never[] | undefined;
  constructor(
    public Message: string,
    public Code: number,
    public ErrorCode: ApiClientExceptionErrorCode,
  ) {}

  public getMessage() {
    if (i18next.exists(`errors.${this.ErrorCode}`)) {
      return i18next.t(`errors.${this.ErrorCode}`);
    }

    if (i18next.exists(`errors.${this.Message}`)) {
      return i18next.t(`errors.${this.Message}`);
    }

    return this.Message;
  }
}
